export default import.meta.ROLLDOWN_FILE_URL_vBtHr7BRaOJuicxr4F1qBQ